import PropTypes from "prop-types";
import React, { Component } from "react";
import { NavLink, Switch } from "react-router-dom";

export default class MainMenuDropdown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openDropdown: false
		};
	}

	componentDidMount() {}
	componentWillUnmount() {}

	toggleDropdown = e => {
		e.preventDefault();
		let { openDropdown } = this.state;
		this.setState({ openDropdown: !openDropdown });
	};

	render() {
		let { openDropdown } = this.state;

		return (
			<li className={`nav-item dropdown ${openDropdown ? "active" : ""}`}>
				<div onClick={e => this.toggleDropdown(e)}>
					<a
						href="#"
						className="nav-link dropdown-toggle"
						data-toggle="dropdown"
						role="button"
						aria-expanded="false">
						{this.props.title}
						<object
							data={
								openDropdown
									? "/images/fa/light/angle-up.svg"
									: "/images/fa/light/angle-down.svg"
							}
							type="image/svg+xml"
						/>
						{/* <span
							className={`fal fa-1x fa-fw ${
								openDropdown ? "fa-angle-up" : "fa-angle-down"
							}`}
						/> */}
					</a>
					{this.props.children}
				</div>
			</li>
		);
	}
}
